import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StepItemProps } from "apis/step";
import { PaginationProps } from "utils/types/API";

export interface StepState {
    loading: boolean;
    list: {
        data: StepItemProps[];
        options: StepItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: StepItemProps;
    };
}

const initialState: StepState = {
    loading: false,
    list: {
        data: [],
        options: []
    },
    item: {
    }
};

interface IndexProps {
    data: StepItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: StepItemProps;
}
export const stepSlice = createSlice({
    name: "step",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, find, create, update } = stepSlice.actions;
export default stepSlice.reducer;
